import * as React from 'react';
import { useEffect, useState } from 'react';
import useCrew from '@/src/Production/components/hooks/useCrew';

/* My profile — identity read-only; phone/city/state/skills/languages
   editable (same field set the ops portal allowed). */

export default function CrewProfileV2() {
    const { getProfile, updateProfile } = useCrew();
    const [profile, setProfile] = useState<any | null>(null);
    const [draft, setDraft] = useState<any>(null);
    const [saving, setSaving] = useState(false);
    const [saved, setSaved] = useState(false);

    useEffect(() => {
        let mounted = true;
        (async () => {
            const data = await getProfile().catch(() => null);
            if (!mounted) return;
            setProfile(data);
            if (data)
                setDraft({
                    phone: data.phone ?? '',
                    city: data.city ?? '',
                    state: data.state ?? '',
                    skills: (data.skills ?? []).join(', '),
                    languages: (data.languages ?? []).join(', '),
                });
        })();
        return () => {
            mounted = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const save = async () => {
        setSaving(true);
        setSaved(false);
        const parseList = (value: string) =>
            value
                .split(',')
                .map((v: string) => v.trim())
                .filter(Boolean);
        const ok = await updateProfile({
            phone: draft.phone.trim() || null,
            city: draft.city.trim() || null,
            state: draft.state.trim() || null,
            skills: parseList(draft.skills),
            languages: parseList(draft.languages),
        })
            .then(() => true)
            .catch(() => false);
        setSaving(false);
        if (ok) {
            setSaved(true);
            setTimeout(() => setSaved(false), 2000);
        }
    };

    if (!profile)
        return (
            <main>
                <div className="ps-label mb-1 mt-3.5">Profile</div>
                <div className="text-[13px] text-faint">Loading…</div>
            </main>
        );

    return (
        <main>
            <div className="ps-label mb-1 mt-3.5">Profile</div>
            <h1 className="m-0 mb-1 text-[20px] font-semibold tracking-[-0.02em]">
                {[profile.firstName, profile.lastName]
                    .filter(Boolean)
                    .join(' ')}
            </h1>
            <div className="mb-6 text-[13px] text-muted-foreground">
                {profile.email}
            </div>

            {draft && (
                <>
                    {(
                        [
                            ['phone', 'Phone'],
                            ['city', 'City'],
                            ['state', 'State'],
                            ['skills', 'Skills (comma-separated)'],
                            ['languages', 'Languages (comma-separated)'],
                        ] as const
                    ).map(([key, label]) => (
                        <div key={key} className="mb-4">
                            <label className="mb-1.5 block text-[12px] font-semibold text-muted-foreground">
                                {label}
                            </label>
                            <input
                                className="ps-input w-full text-[14px]"
                                value={draft[key]}
                                onChange={(e) =>
                                    setDraft((d: any) => ({
                                        ...d,
                                        [key]: e.target.value,
                                    }))
                                }
                            />
                        </div>
                    ))}
                    <button
                        type="button"
                        disabled={saving}
                        onClick={save}
                        className="mt-1 flex h-11 w-full cursor-pointer items-center justify-center rounded-full border-0 bg-foreground font-[inherit] text-[14px] font-semibold text-background disabled:opacity-60"
                    >
                        {saving ? 'Saving…' : saved ? 'Saved' : 'Save changes'}
                    </button>
                </>
            )}
        </main>
    );
}
